import React from 'react'

const face = () => {
  return (
    <div>
      <h1>HI</h1>
    </div>
  )
}

export default face